import React from "react";
import { TrendingUp, TrendingDown, Layers, Calendar } from "lucide-react";

function formatBRL(n) {
  const sign = n < 0 ? "-" : n > 0 ? "+" : "";
  return `${sign}R$ ${Math.abs(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function formatBRLPlain(n) {
  return `R$ ${Math.abs(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function StatsCards({ stats, weekly365 }) {
  if (!stats) return null;
  const profitPositive = stats.total_profit >= 0;

  const items = [
    {
      key: "profit",
      label: "Lucro Total",
      value: formatBRL(stats.total_profit),
      icon: profitPositive ? TrendingUp : TrendingDown,
      color: profitPositive ? "#00FF66" : "#FF3B30",
      testId: "stat-total-profit",
    },
    {
      key: "weekly365",
      label: "Semanal 365",
      value: formatBRLPlain(weekly365?.stake || 0),
      icon: Calendar,
      color: "#60A5FA",
      testId: "stat-weekly-365",
    },
    {
      key: "entries",
      label: "Operações",
      value: stats.total_entries.toString(),
      icon: Layers,
      color: "#FFFFFF",
      testId: "stat-total-entries",
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-3 md:gap-6">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.key}
            data-testid={item.testId}
            className="group relative overflow-hidden rounded-xl border border-white/10 bg-[#121212] p-3 hover:border-white/20 md:p-5"
            style={{ transition: "border-color 0.2s ease, transform 0.2s ease" }}
          >
            <div className="mb-2 flex items-center justify-between md:mb-4">
              <span className="text-[0.7rem] font-medium uppercase tracking-widest text-zinc-500 md:text-[0.75rem]">
                {item.label}
              </span>
              <Icon className="h-3.5 w-3.5 md:h-4 md:w-4" style={{ color: item.color }} strokeWidth={2} />
            </div>
            <div className="font-mono-num text-xl font-bold tabular-nums md:text-3xl" style={{ color: item.color }}>
              {item.value}
            </div>
            <div className="mt-1 h-px w-full bg-gradient-to-r from-white/10 to-transparent" />
          </div>
        );
      })}
    </div>
  );
}
